module.exports = __webpack_public_path__ + "img/api-logo-cardeno2.05bb339f.png";